/*
 * BMS builder UX (ported from the Remainder draft, Brent 2026-09-30). bar-builder.js is unchanged; everything here
 * forwards to or reads from it.
 *  1. The box rows are the scent picker. The pill strip is hidden (kept for bar-builder.js); tapping a row's name
 *     forwards a click to its pill, so the gallery switches exactly as before. bar-builder.js marks the row .is-focused.
 *  2. Tier guidance: running bar count in the box title, the active tier pill filled, and a small flag on the next
 *     tier only when it is one or two bars away ("2 more bars").
 *  3. Phones and tablets: colour swatches under the gallery, built from the rows, with the scent name as an eyebrow.
 *     No "Smells like" line on BMS (Brent).
 */
(() => {
  document.addEventListener('click', (event) => {
    const select = event.target.closest('bar-builder [data-bms-row-select]');
    if (!select) return;
    const builder = select.closest('bar-builder');
    const row = select.closest('[data-scent-row]');
    const pill = row && builder.querySelector(`.bar-builder__pill-strip [data-scent-pill][data-variant-id="${row.dataset.variantId}"]`);
    if (pill) pill.click();
  });

  const tierGuide = (builder) => {
    const title = builder.querySelector('.bar-builder__box-title');
    const ladder = builder.querySelector('.bar-builder__tiers');
    if (!title || !ladder || builder.dataset.bmsTierGuide) return;
    builder.dataset.bmsTierGuide = 'true';
    const count = document.createElement('span');
    count.className = 'bar-builder__box-count';
    title.append(count);
    const flag = document.createElement('span');
    flag.className = 'bar-builder__tier-flag';
    flag.setAttribute('aria-live', 'polite');
    const update = () => {
      const bars = Number(builder.totalBars) || 0;
      count.textContent = ` \u00b7 ${bars} ${bars === 1 ? 'bar' : 'bars'}`;
      const tiers = Array.isArray(builder.tiers) ? builder.tiers : [];
      const index = tiers.findIndex((tier) => tier.max === null || bars <= tier.max);
      const next = index > -1 ? tiers[index + 1] : null;
      const need = next && tiers[index].max !== null ? tiers[index].max + 1 - bars : 0;
      const target = ladder.querySelector(`[data-tier-index="${index + 1}"]`);
      if (bars > 0 && next && need > 0 && need <= 2 && target) {
        flag.textContent = `${need} more ${need === 1 ? 'bar' : 'bars'}`;
        if (flag.parentElement !== target) target.append(flag);
      } else {
        flag.remove();
      }
    };
    const later = () => setTimeout(update, 0);
    builder.addEventListener('click', later);
    builder.addEventListener('input', later);
    builder.addEventListener('change', later);
    new MutationObserver(later).observe(ladder, { subtree: true, attributes: true, attributeFilter: ['class'] });
    update();
  };

  const swatches = (builder) => {
    const section = builder.closest('.shopify-section, section') || document;
    const gallery = section.querySelector('product-gallery') || document.querySelector('product-gallery');
    if (!gallery || document.querySelector('[data-bms-swatches]')) return;
    const rows = Array.from(builder.querySelectorAll('[data-scent-row]'));
    if (rows.length < 2) return;
    const wrap = document.createElement('div');
    wrap.className = 'bms-scent-swatches';
    wrap.dataset.bmsSwatches = '';
    const list = document.createElement('div');
    list.className = 'bms-scent-swatches__list';
    list.setAttribute('role', 'group');
    list.setAttribute('aria-label', 'Scent');
    const name = document.createElement('p');
    name.className = 'bms-scent-swatches__name';
    name.setAttribute('aria-live', 'polite');
    const items = rows.map((row) => {
      const dot = row.querySelector('.bar-builder__dot');
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'bms-scent-swatch';
      button.style.setProperty('--swatch', dot?.style.getPropertyValue('--swatch-background') || '#cfcdc8');
      button.setAttribute('aria-label', row.dataset.variantTitle || '');
      button.addEventListener('click', () => row.querySelector('[data-bms-row-select]')?.click());
      list.append(button);
      return { button, row };
    });
    wrap.append(list, name);
    gallery.after(wrap);
    const sync = () => {
      let active = null;
      items.forEach((item) => {
        const on = item.row.classList.contains('is-focused');
        item.button.setAttribute('aria-pressed', on ? 'true' : 'false');
        if (on) active = item;
      });
      name.textContent = active ? active.row.dataset.variantTitle || '' : '';
    };
    new MutationObserver(sync).observe(builder, { subtree: true, attributes: true, attributeFilter: ['class'] });
    sync();
  };

  const run = () => document.querySelectorAll('bar-builder').forEach((builder) => { tierGuide(builder); swatches(builder); });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run);
  else run();
  customElements.whenDefined('bar-builder').then(run);
})();
